export default __webpack_public_path__ + "static/media/Samung-Cinc-Logo-Black.c1a6c347.png";